export default __webpack_public_path__ + "static/media/img_banner_publisher.b042a022.png";